<template>
  <div class="thousand_layout" v-loading.fullscreen="loading">
    <div class="warehouse_box">
      <!-- v-if="historyTab==0&&!nofind" -->
      <!-- <div class="pay" @click="pay" >SELECT ALL & PAY</div> -->
      <div class="bids_tabs">
        <div @click="HistoryTabs(0)" :class="{'on':(historyTab==0)}">{{ $t('base.itemWarehouse') }}<span v-if="warehouseCount.InWareHouse>0">({{warehouseCount.InWareHouse}})</span>
        </div>
        <div @click="HistoryTabs(4)" :class="historyTab==4?'on':''">{{ $t('title.weighed') }}<span v-if="warehouseCount.ToBeWright>0">({{warehouseCount.ToBeWright}})</span></div>
        <div @click="HistoryTabs(1)" :class="historyTab==1?'on':''">{{ $t('base.unpaid') }}<span v-if="warehouseCount.Unpaid>0">({{warehouseCount.Unpaid}})</span></div>
        <div @click="HistoryTabs(2)" :class="historyTab==2?'on':''">{{ $t('base.toBeShipped') }}<span v-if="warehouseCount.Shipping>0">({{warehouseCount.Shipping}})</span></div>
        <div @click="HistoryTabs(3)" :class="historyTab==3?'on':''">{{ $t('base.shipped') }}<span v-if="warehouseCount.Shipped>0">({{warehouseCount.Shipped}})</span></div>
        <div @click="HistoryTabs(5)" :class="historyTab==5?'on':''">{{ $t('base.completed') }}<span v-if="warehouseCount.ShippComplete>0">({{warehouseCount.ShippComplete}})</span></div>
      </div>
      <!-- 选仓标题 -->
      <h4 v-if="historyTab==0" class="selectWarehouseTitle">{{$t('title.seletWarehouse')}}</h4>
      <!-- 提示 -->
      <!-- <div class="cardAlert" v-if="historyTab==0">
        <el-alert :title="$t('alert.warehouseMaximum')" type="info" show-icon>
        </el-alert>
      </div> -->
      <!-- 选仓 -->
      <div class="selectWarehouse" v-if="historyTab==0" >
        <span v-for="(item,index) in AgencyDetail" :key="index" :class="{'on':(item.Id==AgencyId)}" @click="GetCommodities(item.Id)"> {{item.Nation}} ({{item.Count}})</span>
      </div>
      <!-- historyTab==0&&!nofind&&list.length>0 -->
      <div class="warehouse_box_historyTab" v-if="historyTab==0">
        <!--  v-if="historyTab==0&&!nofind&&list.length>0" -->
        <el-form ref="historyForm" class="history_form" :model="form" v-if="historyTab==0">
          <el-form-item class="history_form_item" :label="$t('base.title')">
            <el-input v-model="form.title" class="info_ipt" :placeholder="$t('base.itemTitle')" @change="GetCommodities"></el-input>
          </el-form-item>
          <el-button type="primary" class="history_form_btn" @click="GetCommodities()">{{ $t('base.search') }}</el-button>
        </el-form>
        <el-button class="pay" @click="pay" :disabled="disabled" v-if="historyTab==0&&!nofind&&list.length>0">{{ $t('symbol.selectAllWeight') }}</el-button>
        <el-button class="pay" :disabled="true" v-else>{{ $t('symbol.selectAllWeight') }}</el-button>
        <span class="InternationalPay" @click="ShippingFee" v-if="historyTab==0">{{ $t('colon.internationalShippingFee') }}</span>
        <get-weight title="" :domVisible='dislogType.weight' :list="dislogData" :dialogClass="'weight alertWeightList'" @closeDialog="closeDialog" v-if='dislogType.weight' />
        <tax-declaration dialogClass="taxDeclarationDialog" :dialogVisible.sync='dislogType.taxDeclaration' :agencyCode="AgencyCode" :agencyCount='AgencyCount' @closeDialog="closeDialog"  v-if='dislogType.taxDeclaration'></tax-declaration>
      </div>
      <!--  v-if="historyTab==0&&!nofind&&list.length>0" -->
      <!-- 在仓未生成转运订单的商品列表 -->
      <div class="table_head historyTab" v-if="historyTab==0&&!nofind&&list.length>0">
        <!-- &&!nofind -->
        <div class="head_box item">{{ $t('base.item') }}</div>
        <!-- <div class="head_box itemPrice">{{ $t('base.itemPrice') }}</div> -->
        <div class="head_box quantity">{{ $t('base.quantity') }}</div>
        <div class="head_box estimatedStateTax">{{$t('base.estimatedStateTax')}}</div>
        <div class="head_box shippingFee">{{$t('base.cardhobbyPay')}}</div>
        <div class="head_box timeInWarehouse">{{ $t('base.timeInWarehouse') }}</div>
        <div class="head_box operate">{{ $t('base.operate') }}</div>
      </div>
      <div class="table_head historyTab nowarehouse" v-if="historyTab!=0&&!nofind&&list.length>0">
        <div class="head_box item">{{ $t('base.item') }}</div>
        <div class="head_box itemPrice">{{ $t('base.itemPrice') }}</div>
        <div class="head_box weighed">{{ $t('base.weighed') }}</div> 
        <div class="head_box estimatedStateTax">{{$t('base.ForwardingOrderTotal')}}</div> 
        <div class="head_box orderInfo">{{$t('base.OrderInformation')}}</div>
      </div>
      <warehouse-list :list="list"  :userInfo='userInfo' :type="historyTab" v-if="!nofind" />
      <n-o-t-n class="notfind" title="" text="No Data" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" text="Pagefault" v-else />
      <list-pagination class="" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!nofind && list.length>0" />
    </div>
  </div>
</template>
<script>
import WarehouseList from "@/components/list/warehouse"
import ListPagination from '@/components/listpagination'
import FZF from "@/components/404.vue";
import NOTN from "@/components/notnull";
import GetWeight from "@/components/dialog/weight"; // 稱重
import TaxDeclaration from "@/components/dialog/taxDeclaration"; // 稱重

import { addressList, numAdd, numMulti, priceExchange, isNumber,getAreaForSymbol} from "@/api/public";
export default {
  name: 'tabslist',
  components: { ListPagination, WarehouseList, NOTN, FZF,GetWeight,TaxDeclaration},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
      dislogData:{},
      loading: false,
      disabled: false,
      resultTpye: '',
      historyTab: 0,
      list: {},
      nofind: false,
      warehouseCount: '',
      AgencyId: 2,
      AgencyCode: 'US',
      AgencyDetail: {},
      AgencyCount:0,
      pi: 1,
      ps: 60,
      TotalCount: 0,
      TaxPrice: 0,
      form: {
        title: '',
      }
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    if (this.historyTab == 0) {
      this.GetAllAgency()
    }
    this.GetCount()
  },
  mounted() {},
  methods: {
    // 获取办事处全部列表
    /**
     * 获取所有代理商信息
     * 通过用户ID和来源获取代理商列表，并设置默认代理商信息
     * @description 调用接口获取代理商数据，设置当前代理商ID、区域码和数量，并触发商品查询
     * @private
     */
    GetAllAgency() {
      let that = this
      let data = { 'MemberId': that.userInfo.MappingUserId,"MemberSource":that.userInfo.MemberSource }
      that.$get(that.$interface.GetAllAgency, data).then(res => {
        if (res.Result != 0) {

          that.AgencyId = res.Data[0].Id
          that.AgencyCode = res.Data[0].AreaId
          that.AgencyCount=res.Data[0].Count
          that.AgencyDetail = res.Data
        }
        that.GetCommodities(that.AgencyId)
      })
    },
    // 获取税费列表
    /**
     * 获取税费列表并计算商品税费
     * @param {Array} obj - 商品列表数组
     * @description 根据用户所在州获取对应税率,计算商品税费
     * - 调用接口获取各州税率列表
     * - 根据用户所在州匹配对应税率
     * - 遍历商品列表,计算每个商品的税费(USD)
     * - 更新商品列表到组件数据
     */
    GetTaxList(obj) {
      let that = this
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, }
      that.$get(that.$interface.GetTaxList, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          var state = that.userInfo.State
          var Tax = 0
          result.map(res => {
            if (res.StateName == state) {
              Tax = res.TaxPercent / 100
            }
          })
          obj.map(item => {
            var taxPrice = priceExchange(item.Price, 'USD');
            item.TaxPrice = numMulti(taxPrice, Tax).toFixed(2);
          })
          that.list = obj
          //var taxPrice=priceExchange(obj,'USD');
          //that.TaxPrice = numMulti(taxPrice,Tax).toFixed(2);
        }
      })
    },
    // 转运仓tab 数量
    /**
     * 获取仓库数量统计
     * 通过会员ID请求仓库统计数据
     * @method GetCount
     * @private
     * @returns {void} 无返回值,直接更新 warehouseCount 数据
     */
    GetCount() {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId }
      this.$get(this.$interface.GetWarehouseCount, data).then(res => {
        //console.log("warehouseCount", res)
        if (res.Result != 0) {
          that.warehouseCount = res.Data
        }
      })
    },
    // 获取转运仓列表
    /**
     * 获取仓库订单列表
     * @description 根据用户信息和筛选条件获取仓库订单数据
     * @method GetOrder
     * @private
     * @returns {Promise} 返回订单列表数据
     * - 设置加载状态
     * - 根据历史标签状态获取订单
     * - 更新订单列表和总数
     * - 处理无数据情况
     */
    GetOrder() {
      let that = this;
      that.loading = true;
      let Status = that.historyTab != 4 ? that.historyTab : 0
      let data = { Title: that.form.title, OrderStatus: Status, MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps }
      //console.log(data)
      this.$get(this.$interface.GetWarehouseOrders, data).then(res => {
        if (res.Result != 0) {
          //console.log(123, res)
          var result=res.Data
          if (res.Count == 0) {
            that.nofind = true
          } else {
            result.map(item=>{
              var itemPriceTotal = 0
              var orderDetails=item.OrderDetails
              orderDetails.map(it=>{
                if(it.RealLowestPrice){
                  itemPriceTotal=numAdd(itemPriceTotal,it.RealLowestPrice)
                }else{
                var Price=numMulti(it.Price,item.ExchangeRate)
                itemPriceTotal=numAdd(itemPriceTotal,Price)
                }
              })
              item.itemPriceTotal=itemPriceTotal.toFixed(2)
              //console.log(itemPriceTotal,'itemPriceTotal')
            })
            that.nofind = false
          }
          
          that.list = result
          that.TotalCount = res.Count
        } else {
          that.nofind = true
        }
        that.resultTpye = res.Result
        that.loading = false;
      })
      //GetWarehouseOrders
    },
    // 获取在仓未生成转运订单的商品
    /**
     * 获取商品列表数据
     * @param {string|number} value - 代理商ID
     * @description 根据代理商ID获取商品列表,包含以下功能:
     * - 设置代理商相关信息(代理商代码、数量等)
     * - 请求商品分页列表数据
     * - 处理返回结果,包括商品税费计算
     * - 更新列表展示状态(加载中、无数据等)
     */
    GetCommodities(value) {
      let that = this;
      that.loading = true;
      if (value) {
        that.AgencyId = value;
        var code = that.AgencyDetail.filter((item) => { return item.Id==value})
        that.AgencyCode=code[0].AreaId
        that.AgencyCount=code[0].Count
        that.pi=1
        //console.log(code,that.AgencyCode,'code')
      }
      let data = { MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps, AgencyId: that.AgencyId, IsTransport: false, Title: that.form.title }
      this.$get(this.$interface.GetCommoditiesPageList, data).then(res => {
        if (res.Result != 0) {
          if (res.Count == 0) {
            that.nofind = true
          } else {
            that.nofind = false
            that.GetTaxList(res.Data)
          }
          //that.list = res.Data
          //var totalPrice = 0
          // if(res.Count >0){
          //   // 税的计算
          //   res.Data.map(item=>{
          //     totalPrice=numAdd(totalPrice,item.LowestPrice)
          //   })
          // }
          // //console.log("数据", that.list)
          that.TotalCount = res.Count
          // // 税
          // that.GetTaxList(isNumber(totalPrice))
        }
        that.resultTpye = res.Result
        that.disabled = false;
        that.loading = false;
      })
    },
    HistoryTabs(val) {
      let that = this;
      this.list = '';
      this.historyTab = val;
      this.nofind = false
      this.pi = 1;
      this.ps = 60;
      this.form.title = "";
      if (val != 0) {
        this.GetOrder()
      } else {
        this.GetAllAgency()
        //this.GetCommodities()
      }
    },
    //创建转运订单
    /**
     * 提交订单请求
     * @param {Object} obj - 订单相关参数对象
     * @description 向服务器发送设置订单请求,包含会员ID、代理ID和数据来源等信息
     * 请求成功后提示称重信息并跳转历史记录,失败则显示错误信息
     * @fires this.$message - 触发消息提示
     * @fires this.HistoryTabs - 触发历史记录标签切换
     */
    setOrder(obj) {
    //console.log(this.userInfo, 'userInfo')

      let that = this

      that.loading = true;
      that.disabled = true;
      // let AddressDetail = this.userInfo.address;
      // let address = {
      //   AddressId: AddressDetail.Id,
      //   Consignee: AddressDetail.UserName,
      //   Mobile: AddressDetail.Phone,
      //   ZipCode: AddressDetail.ZipCode,
      //   //Provice: AddressDetail.StateCode,
      //   Provice: AddressDetail.State,
      //   City: AddressDetail.City,
      //   AddressDetail: AddressDetail.StreetAddress + (AddressDetail.StreetAddress2 ? '(' + AddressDetail.StreetAddress2 + ')' : ''),
      //   Nation: AddressDetail.Country,
      // }
      let data = { MemberId: this.userInfo.MappingUserId, AgencyId: that.AgencyId, DataSource: that.userInfo.MemberSource}
      data={...data,...obj}
      let url = this.$interface.SetOrder
      //console.log(data,'data')
      //return
      this.$post(url, data).then(res => {
        if (res.result==1) {
          this.$message({
            type: 'success',
            duration: 1000,
            message: that.$t('alert.weWillWeighSoon')
          });
          that.GetCount()
          that.HistoryTabs(4)
        } else {
          that.disabled = false;
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

        that.loading = false;
      })
    },
    /**
     * 显示称重确认对话框并处理用户选择
     * 当用户确认后打开税务申报对话框
     * @function pay
     * @description 弹出确认对话框询问用户是否已称重,确认后显示税务申报界面
     * @example
     * this.pay()
     */
    pay() {
      let that = this
      this.$confirm('<div class="confirmData">' + that.$t('alert.weighTip') + '</div>', that.$t('title.weighed'), {
        confirmButtonText: that.$t('base.yes'),
        cancelButtonText: that.$t('base.no'),
        customClass: "confirmBox",
        lockScroll: false,
        dangerouslyUseHTMLString: true
      }).then(() => {
        that.dislogType.taxDeclaration = true;
      }).catch(() => {});
      //
      // let data = { AddressId: '', Details: this.list };
      // window.sessionStorage.setItem('check', JSON.stringify(data))
      // this.$router.push({
      //   path: '/pay/warehouse'
      // })
    },
    /**
     * 显示运费价格列表弹窗
     * 根据用户所在地区和代理商ID获取重量区间对应的国际运费
     * 
     * @param {Object} data - 请求参数
     * @param {number} data.pageIndex - 页码
     * @param {number} data.pageSize - 每页数量 
     * @param {string} data.region - 用户所在地区
     * @param {string} data.agencyId - 代理商ID
     * 
     * @fires this.$alert - 弹出运费价格列表对话框
     * @fires this.$get - 调用获取重量区间价格列表接口
     */
    ShippingFee() {
    // 价格列表
      let that = this
      //that.loading = true;
      let data = { pageIndex: 1, pageSize: 99, region: that.userInfo.MemberSource, agencyId: that.AgencyCode }
      that.dislogData=data
      that.dislogType.weight = true;

      // this.$get(this.$interface.GetWeightList, data).then(res => {
      //   if (res.Result != 0) {
      //     that.loading = false;
      //     var result = res.Data
      //     let htmlLi = ''
      //     result.map(item => {
      //       htmlLi += '<li><span>' + (item.MinWeight > 0 ? item.MinWeight + 'kg' : item.MinWeight) + ' ~ ' + item.MaxWeight + `kg（${that.$t('base.included')}）</span><span>$` + item.WeightFeeUSD + '</span></li>'
      //     })
      //     let html = `<div class="tab_dasap">
      //           <ul class="tab_dasap_ul">
      //             <li class="tab_dasap_title"><span>${that.$t('base.weight')}</span><span>${that.$t('base.internationalShippingFee')}</span>
      //             </li>
      //             ` + htmlLi + `
      //           </ul>
      //         </div>`
      //     this.$alert(html, '', {
      //       confirmButtonText: this.$t('base.confirm'),
      //       customClass: "confirmBox alertWeightList",
      //       lockScroll: false,
      //       dangerouslyUseHTMLString: true,
      //       callback: action => {}
      //     });
      //   }
      // })

      // this.$confirm(html, '', {
      //     confirmButtonText: 'Yes',
      //     cancelButtonText: '',
      //     customClass: "confirmBox",
      //     lockScroll: false,
      //     dangerouslyUseHTMLString: true
      //   }).then(() => {
      //     //this.setOrder(obj)
      //   }).catch(() => {});
    },

    closeDialog(val, bol,obj,bol2) {
      if(val!='taxDeclaration'){
        this.dislogType[val] = bol;
      }else{
        if(bol2){
          this.setOrder(obj)
        }
        this.dislogType[val] = bol;
      }
    },
    // 获取税费列表
    // GetTaxList(obj) {
    //   let that = this
    //   let data = {'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId,}
    //   that.$get(that.$interface.GetTaxList, data).then(res => {
    //     if (res.result != 0) {
    //       var result=res.data
    //       var state=that.userInfo.State
    //       var Tax=0
    //       result.map(res=>{
    //         if(res.StateName==state){
    //           Tax=res.TaxPercent/100
    //         }
    //       })
    //       var taxPrice=priceExchange(obj,'USD');
    //       that.TaxPrice = numMulti(taxPrice,Tax).toFixed(2);
    //     }
    //   })
    // },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.nofind = false
      this.form.title = "";

      if (this.historyTab != 0) {
        this.GetOrder()
      } else {
        //this.GetAllAgency()
        this.GetCommodities()
      }

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.nofind = false
      this.form.title = "";
      if (this.historyTab != 0) {
        this.GetOrder()
      } else {
        //this.GetAllAgency()
        this.GetCommodities()
      }
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/purchasehistory.css";

@import "../../../static/css/warehouse.css";

.historyTab {
  align-items: center;
  height: auto;
  padding: 5px 0;
}

.warehouse_box,
.warehouse_box_historyTab {
  position: relative;
}

.warehouse_box>.pay {
  border: none !important;
  position: absolute;
  right: 0;
  background: #58A800;
  padding: 10px 12px;
  top: 70px;
  margin: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}

.warehouse_box>.pay.el-button--default.is-disabled {
  opacity: 0.5;
  cursor: no-drop;
}

.warehouse_box_historyTab>.pay {
  border: none !important;
  position: absolute;
  right: 0;
  background: #58A800;
  padding: 10px 12px;
  top: 33px;
  margin: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}

.warehouse_box_historyTab>.pay.el-button--default.is-disabled {
  opacity: 0.5;
  cursor: no-drop;
}

.history_form {
  padding-top: 30px;
}

.warehouse_box_historyTab>.InternationalPay {

  top: 70px;
}

.warehouse_box_historyTab>.Estimated {
  top: 13px;
  position: absolute;
  right: 0;
  font-size: 14px;
}

.nowarehouse {
  margin-top: 20px;
}

.nowarehouse .commod {
  width: 204px;
  margin-left: 56px;
}

.nowarehouse .Number {
  width: 100px;
}

.nowarehouse .tracking {
  /*width: 190px;*/
  width: 150px;
}

.nowarehouse .shippingFee {
  width: 190px;
  /*width: 164px;*/
}

.nowarehouse .stateTax {
  width: 110px;
}

.nowarehouse .transfer {
  width: 243px;
  margin-left: 0;
  margin-right: 17px;
}

.selectWarehouseTitle {
  margin: 20px 0 12px;
  font-size: 16px;
}

.selectWarehouse {
  display: flex;
  flex-wrap: wrap;
}

.selectWarehouse span {
  display: block;
  cursor: pointer;
  margin-right: 12px;
  margin-bottom: 12px;
  padding: 0 12px;
  height: 36px;
  line-height: 36px;
  background-color: #f7f7f7;
  border-radius: 4px;
}

.selectWarehouse span.on {
  background-color: #f0f3ff;
  color: #5F6DAE;
  font-weight: 700;
}

/deep/ .cardAlert .el-alert__title {
  display: inline-block;
  width: 95%;
  font-size: 14px;
}

/deep/ .cardAlert .el-alert {
  padding: 16px;
  margin: 0 0 12px;
}

/deep/ .cardAlert .el-alert__closebtn {
  margin-top: 17px;
  font-size: 16px;
}

.warehouse_box_historyTab>.pay.el-button--default.is-disabled {
  background: #a0a0a0;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/warehouse.vue